export default __webpack_public_path__ + "static/media/arrow-right.02e96351.svg";